const FILE_EXTENSION_TYPES = {
    deckspec: 'yaml',
    yml: 'yaml',
    yaml: 'yaml',
    json: 'json',
    template: 'yaml',
    sh: 'sh',
    zip: 'zip'
};

class FaroDeckFileTreeHelper {
    findFileInTree(rootNode: any, nodeId: string) {
        const listToExplore = [rootNode];

        while (listToExplore.length) {
            const node = listToExplore.pop();
            if (node.id === nodeId) {
                return node;
            } else {
                node.children.forEach(child => listToExplore.push(child));
            }
        }
    }

    getFileType(name) {
        const index = name.lastIndexOf('.');
        let type = 'text';
        if (index !== -1) {
            const extension = name.substring(index + 1, name.length);
            if (FILE_EXTENSION_TYPES[extension]) {
                type = FILE_EXTENSION_TYPES[extension];
            }
        }
        return type;
    }
}

export default FaroDeckFileTreeHelper;